import { PackagePermission } from 'shared/models/user';
import { OrgLevelPermission } from '../components/OrgProvider';

export interface Package {
  name: string;
  uuid: string;
  description?: string;
}

export interface OrganizationPackages {
  organizationUuid: string;
  packages: Package[];
}

export interface PackageByUUID extends Package {
  accessPolicies: AccessPolicy[];
}

export interface AccessPolicy {
  role: string;
  permissions: OrgLevelPermission[];
}

export interface PackagePermissionWithDescription {
  name: PackagePermission;
  description: string;
}

export interface PackageOrganizationList {
  packageUuid: string;
  organizations: OrganizationForPackage[];
}

export interface OrganizationForPackage {
  name: string;
  uuid: string;
}

// org roles persisted in octopaas
export enum PackagesOrgRole {
  ADMIN = 'admin',
  DEVELOPER = 'developer',
  SPECIALIST = 'specialist',
  MEMBER = 'member',
  DSC = 'dsc',
  SYSTEM_USER = 'systemaccount',
}
